(function () {
  var ACTIVE = 'site-nav--active-dropdown';
  var HOVER_OPEN = 'is-hover-open';
  var HIDE_DELAY = 200;
  var mq = window.matchMedia('(min-width: 750px)');

  function initHeaderNavHover() {
    var nav = document.getElementById('AccessibleNav');
    if (!nav || nav.dataset.navHoverBound === 'true') return;
    nav.dataset.navHoverBound = 'true';

    var hideTimers = new WeakMap();
    var pinnedItem = null;

    function clearHideTimer(item) {
      var timer = hideTimers.get(item);
      if (timer) {
        clearTimeout(timer);
        hideTimers.delete(item);
      }
    }

    function setExpanded(item, expanded) {
      var btn = item.querySelector('.site-nav__link--main');
      if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function closeItem(item, immediate) {
      if (!item || (pinnedItem === item && !immediate)) return;

      clearHideTimer(item);
      item.classList.remove(HOVER_OPEN);
      item.classList.remove(ACTIVE);
      setExpanded(item, false);

      if (pinnedItem === item && immediate) {
        pinnedItem = null;
      }
    }

    function closeOtherDropdowns(current) {
      nav.querySelectorAll('[data-has-dropdowns]').forEach(function (item) {
        if (item === current) return;
        closeItem(item, true);
      });
    }

    function openItem(item) {
      clearHideTimer(item);
      closeOtherDropdowns(item);
      item.classList.add(HOVER_OPEN);
      item.classList.add(ACTIVE);
      setExpanded(item, true);
    }

    function scheduleClose(item) {
      if (pinnedItem === item) return;

      clearHideTimer(item);
      hideTimers.set(
        item,
        setTimeout(function () {
          closeItem(item, false);
          hideTimers.delete(item);
        }, HIDE_DELAY)
      );
    }

    function forceCloseAll() {
      pinnedItem = null;
      nav.querySelectorAll('[data-has-dropdowns]').forEach(function (item) {
        closeItem(item, true);
      });
    }

    nav.querySelectorAll('.site-nav > li').forEach(function (li) {
      if (li.classList.contains('site-nav__separator')) return;

      li.addEventListener('mouseenter', function () {
        if (li.hasAttribute('data-has-dropdowns')) {
          openItem(li);
          return;
        }

        closeOtherDropdowns(null);
      });
    });

    nav.querySelectorAll('[data-has-dropdowns]').forEach(function (item) {
      var dropdown = item.querySelector('.site-nav__dropdown');
      var button = item.querySelector('.site-nav__link--main');
      if (!dropdown) return;

      item.addEventListener('mouseleave', function (e) {
        if (dropdown.contains(e.relatedTarget)) return;
        scheduleClose(item);
      });

      dropdown.addEventListener('mouseenter', function () {
        openItem(item);
      });

      dropdown.addEventListener('mouseleave', function (e) {
        if (item.contains(e.relatedTarget)) return;
        scheduleClose(item);
      });

      if (button) {
        button.addEventListener('click', function () {
          window.setTimeout(function () {
            if (item.classList.contains(ACTIVE)) {
              pinnedItem = item;
              item.classList.remove(HOVER_OPEN);
            } else if (pinnedItem === item) {
              pinnedItem = null;
            }
          }, 0);
        });
      }
    });

    document.body.addEventListener('click', function (e) {
      if (e.target.closest('#AccessibleNav')) return;
      forceCloseAll();
    });
  }

  function boot() {
    if (!mq.matches) return;
    initHeaderNavHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', boot);
  } else if (mq.addListener) {
    mq.addListener(boot);
  }
})();
